"use client";
import { Suspense } from "react";
import dynamic from "next/dynamic";

import Skeleton from "../Skeleton";

const AudioClassification = dynamic(() =>
  import("@mui/icons-material/GraphicEqRounded")
);
const Chat = dynamic(() => import("@mui-symbols-material/w400/ForumRounded"));
const Summarize = dynamic(() => import("@mui/icons-material/ShortTextRounded"));
const TextGeneration = dynamic(() =>
  import("@mui/icons-material/TitleRounded")
);
const Translate = dynamic(() => import("@mui/icons-material/TranslateRounded"));
const TextToImage = dynamic(() =>
  import("@mui-symbols-material/w400/ImageRounded")
);
const TextToVideo = dynamic(() =>
  import("@mui-symbols-material/w400/MovieRounded")
);
const ImageToText = dynamic(() =>
  import("@mui/icons-material/FormatShapesRounded")
);
const Asr = dynamic(() => import("@mui/icons-material/RecordVoiceOverRounded"));
const DepthEstimation = dynamic(() =>
  import("@mui-symbols-material/w400/StacksRounded")
);
const DocQA = dynamic(() =>
  import("@mui-symbols-material/w400/UnknownDocumentRounded")
);
const FeatureExtraction = dynamic(() =>
  import("@mui-symbols-material/w400/FingerprintRounded")
);
const FillMask = dynamic(() =>
  import("@mui-symbols-material/w400/InsertTextRounded")
);
const MaskGeneration = dynamic(() =>
  import("@mui-symbols-material/w400/WallpaperRounded")
);
const ImageClassification = dynamic(() =>
  import("@mui-symbols-material/w400/ImageSearchRounded")
);
const ObjectDetection = dynamic(() =>
  import("@mui-symbols-material/w400/PagelessRounded")
);
const QA = dynamic(() => import("@mui-symbols-material/w400/HelpRounded"));
const SentenceSimilarity = dynamic(() =>
  import("@mui-symbols-material/w400/TextCompareRounded")
);
const TTA = dynamic(() => import("@mui-symbols-material/w400/VolumeUpRounded"));
const ImageGeneration = dynamic(() =>
  import("@mui-symbols-material/w400/AddPhotoAlternateRounded")
);
const VideoClassification = dynamic(() =>
  import("@mui-symbols-material/w400/VideoCameraFrontRounded")
);
const VQA = dynamic(() =>
  import("@mui-symbols-material/w400/IndeterminateQuestionBoxRounded")
);

export default function ModelTaskIcon({ task, ...props }) {
  const Icon =
    {
      "audio-classification": AudioClassification,
      "automatic-speech-recognition": Asr,
      chat: Chat,
      "depth-estimation": DepthEstimation,
      "document-question-answering": DocQA,
      "feature-extraction": FeatureExtraction,
      "fill-mask": FillMask,
      "image-classification": ImageClassification,
      "image-feature-extraction": FeatureExtraction,
      "image-segmentation": TextToImage,
      "image-to-text": ImageToText,
      "mask-generation": MaskGeneration,
      "object-detection": ObjectDetection,
      "question-answering": QA,
      "sentence-similarity": SentenceSimilarity,
      summarization: Summarize,
      "text-classification": FillMask,
      "text-generation": TextGeneration,
      "text-to-audio": TTA,
      "text-to-image": TextToImage,
      "text-to-speech": Asr,
      "text-to-video": TextToVideo,
      "text2text-generation": TextGeneration,
      translation: Translate,
      "token-classification": FillMask,
      "unconditional-image-generation": ImageGeneration,
      "video-classification": VideoClassification,
      "visual-question-answering": VQA,
      "zero-shot-classification": FillMask,
      "zero-shot-image-classification": ImageClassification,
      "zero-shot-object-detection": ObjectDetection
    }[task] || (() => null);

  return (
    <Suspense
      fallback={<Skeleton height={16} width={16} borderRadius="xs-round" />}
    >
      <Icon {...props} />
    </Suspense>
  );
}
